import { RESET_STATE } from 'store/global/actions';
import { EMAIL_TEMPLATES_PROCESSING_TYPE } from 'store/system/actions';

const initialState = {};

const emailTemplatesProcessingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EMAIL_TEMPLATES_PROCESSING_TYPE.GET_SPECIAL_LINKS:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default emailTemplatesProcessingReducer;
